import { render, staticRenderFns } from "./RiscoClienteGrupo.vue?vue&type=template&id=5f1a843c&scoped=true"
import script from "./RiscoClienteGrupo.vue?vue&type=script&lang=js"
export * from "./RiscoClienteGrupo.vue?vue&type=script&lang=js"
import style0 from "./RiscoClienteGrupo.vue?vue&type=style&index=0&id=5f1a843c&prod&scoped=true&lang=css"
import style1 from "./RiscoClienteGrupo.vue?vue&type=style&index=1&id=5f1a843c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1a843c",
  null
  
)

export default component.exports